import AudioPlayer from './AudioPlayer.vue'
import CategoryListAccordion from './CategoryListAccordion.vue'
import LoginLink from './LoginLink.vue'
import PopoverItem from './PopoverItem.vue'
import SvgIcon from './SvgIcon.vue'
import CouponModal from './CouponModal.vue'
import LiteYouTubeWrapper from './LiteYouTubeWrapper.vue'

const globalComponents = [
  AudioPlayer,
  CategoryListAccordion,
  LoginLink,
  PopoverItem,
  SvgIcon,
  CouponModal,
  LiteYouTubeWrapper,
]

export default globalComponents
